import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Card, Button, Separator, Text } from '@/ui'

import { fetchTransactionCounts } from '@/actions/adminActions'
import TransactionImportModal from './TransactionImportModal'
import { User } from '@/reducers/auth/userReducer'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'

export const UserTransactionsCard = ({ user }: { user: User }) => {
  const dispatch = useAppDispatch()
  const [counts, setCounts] = useState<{
    pendingCount: number
    uncategorizedCount: number
    requestedClarificationCount: number
  }>()
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    async function fetchData() {
      const counts = await fetchTransactionCounts({ userId: user.id })(dispatch)
      setCounts(counts)
    }
    fetchData()
  }, [dispatch, user])

  return (
    <Card className="userTransactionsCard">
      <div className="flex flex-row justify-between items-center">
        <Text variant={TypographyStyles.H1}>Transactions</Text>
        <Button variant="link" onClick={() => setModalOpen(true)}>
          Manual Upload
        </Button>
        {modalOpen && (
          <TransactionImportModal
            user={user}
            open={modalOpen}
            close={() => setModalOpen(false)}
          />
        )}
      </div>
      <Separator />

      <div className="flex flex-row justify-between items-center w-2/3">
        <div className="flex justify-center gap-2">
          <Text variant={TypographyStyles.BODY_LG}>
            {counts?.uncategorizedCount}
          </Text>
          <Text variant={TypographyStyles.BODY_LG}>Uncategorized</Text>
        </div>
        <div className="flex justify-center gap-2">
          <Text variant={TypographyStyles.BODY_LG}>
            {counts?.requestedClarificationCount}
          </Text>
          <Text variant={TypographyStyles.BODY_LG}>Needs Clarification</Text>
        </div>
        <div className="flex justify-center gap-2">
          <Text variant={TypographyStyles.BODY_LG}>{counts?.pendingCount}</Text>
          <Text variant={TypographyStyles.BODY_LG}>Pending</Text>
        </div>
      </div>
      <Separator />
      <div className="flex justify-end">
        <Link to={`/admin/finances/transactions/${user.id}`}>
          <Button variant="link">View All User Transactions</Button>{' '}
          &gt;&gt;&gt;{' '}
        </Link>
      </div>
    </Card>
  )
}
